export default __webpack_public_path__ + "static/media/Solutions1000@3x.a253a30c.png";